// import React from 'react';
// import { AzureMP } from 'react-azure-mp';
// import { useHistory, useLocation } from 'react-router-dom';
// import './azure-media-player.scss';
// import CustomButton from '../custom-button/custom-button.component';

// export function AzureMediaPlayer() {
//   const history = useHistory();
//   const location = useLocation();
//   const url = location.state;

//   const goBack = () => {
//     history.goBack();
//   };
//   return (
//     <>
//       <div
//         className={
//           'd-flex ' +
//           'justify-content-center ' +
//           'align-items-center ' +
//           'azure-media-player'
//         }
//       >
//         <AzureMP adaptRatio={[4, 3]} skin="amp-flush" src={[{ src: url }]} />
//       </div>
//       <div className="d-flex justify-content-center go-back-button">
//         <CustomButton className="upload-link" onClick={goBack}>
//           Go Back
//         </CustomButton>
//       </div>
//     </>
//   );
// }


// import React from 'react';
// import { AzureMP } from 'react-azure-mp';
// import { useHistory, useLocation } from 'react-router-dom';
// import './azure-media-player.scss';
// import CustomButton from '../custom-button/custom-button.component';
// // import React, { useEffect, useRef } from 'react';
// import 'azuremediaplayer/dist/azuremediaplayer.min.css';

// export function AzureMediaPlayer() {
//   const history = useHistory();
//   const location = useLocation();
//   const url = location.state;
// const VideoPlayer = ({ src }) => {
//   const videoRef = useRef(null);

//   useEffect(() => {
//     if (videoRef.current) {
//       // Dynamically load AMP
//       const script = document.createElement('script');
//       script.src = 'https://cdn.jsdelivr.net/npm/azuremediaplayer/dist/azuremediaplayer.min.js';
//       script.onload = () => {
//         const player = window.amp(videoRef.current, {
//           // AMP options
//           nativeControlsForTouch: false,
//           autoplay: false,
//           controls: true,
//           width: "640",
//           height: "400"
//         });
        
//         player.src([{ src: url }]);
//       };
//       document.head.appendChild(script);
//     }
//   }, [url]);
//   const goBack = () => {
//     history.goBack();
//   };
//   return (
//     <>
//       <div
//         className={
//           'd-flex ' +
//           'justify-content-center ' +
//           'align-items-center ' +
//           'azure-media-player'
//         }
//       >
//         <video
//       ref={videoRef}
//       className="azuremediaplayer amp-default-skin"
//       controls
//     />
//         {/* <AzureMP adaptRatio={[4, 3]} skin="amp-flush" src={[{ src: url }]} /> */}
//       </div>
//       <div className="d-flex justify-content-center go-back-button">
//         <CustomButton className="upload-link" onClick={goBack}>
//           Go Back
//         </CustomButton>
//       </div>
//     </>
//   );
// }
// import React, { useEffect, useRef } from 'react';
// import videojs from 'video.js';
// import 'video.js/dist/video-js.css';
// import { useHistory, useLocation } from 'react-router-dom';
//  import CustomButton from '../custom-button/custom-button.component';

// export function AzureMediaPlayer() {
//   const videoRef = useRef(null);
//    const playerRef = useRef(null);
//   const history = useHistory();
//    const location = useLocation();
//    const url = location.state;
//    const goBack = () => {
//      history.goBack();
//    };

//   useEffect(() => {
//     if (playerRef.current) {
//       playerRef.current.dispose();
//       playerRef.current = null;
//     }

//     const videoElement = videoRef.current;
//     if (!videoElement || !url) return;

//       // const videoElement = videoRef.current;
//       // if (!videoElement) return;

//      const player = videojs(videoElement, {
//         controls: true,
//         responsive: true,
//         fluid: true,
//         width: 640,
//         height: 400,
//         playbackRates: [0.5, 1, 1.25, 1.5, 2],
//         sources: [{ src: url }],
//         // Azure Media Player-like options
//         bigPlayButton: {
//           text: 'Play Video'
//         },
//         controlBar: {
//           volumePanel: {
//             inline: false
//           }
//         }
//       });

//       playerRef.current = player;
    

//     return () => {
//       if (playerRef.current) {
//         playerRef.current.dispose();
//         playerRef.current = null;
//       }
//     };
//   }, [url]);

//   return (
//     <>
//      <div
//          className={
//            'd-flex ' +
//            'justify-content-center ' +
//            'align-items-center ' +
//            'azure-media-player' +
//            'azure-media-player-wrapper'
//          }
//       >
//     <video
//       ref={videoRef}
//       className="video-js vjs-default-skin vjs-azure-skin"
//       controls
//       preload="auto"
//       data-setup="{}"
//     />
//     </div>
//      <div className="d-flex justify-content-center go-back-button">
//         <CustomButton className="upload-link" onClick={goBack}>
//            Go Back
//          </CustomButton>
//        </div>
//        </>
//   );
// }

//import React, { useEffect, useRef } from 'react';
import React, { useRef, useEffect, useState, useCallback } from 'react';
//import { useHistory, useLocation } from 'react-router-dom';
import videojs from 'video.js';
import 'video.js/dist/video-js.css';
import './VideoPlayer.css'; // Custom styles
import { useHistory, useLocation } from 'react-router-dom';

// export function AzureMediaPlayer() {
//   const videoRef = useRef(null);
//   const playerRef = useRef(null);
//    const history = useHistory();
//     const location = useLocation();
//     const url = location.state;
//   useEffect(() => {
//     // Clean up existing player before creating new one
//     if (playerRef.current) {
//       playerRef.current.dispose();
//       playerRef.current = null;
//     }

//     const videoElement = videoRef.current;
//     if (!videoElement || !url) return;

//     // Wait for next tick to ensure DOM is ready
//     const timer = setTimeout(() => {
//       try {
//         const player = videojs(videoElement, {
//           controls: true,
//           responsive: true,
//           fluid: true,
//           width: 540,
//           height: 350,
//           playbackRates: [0.5, 1, 1.25, 1.5, 2],
//           preload: 'auto',
//           // Initialize without sources first
//           bigPlayButton: {
//             text: 'Play Video'
//           },
//           controlBar: {
//             volumePanel: {
//               inline: false
//             }
//           }
//         });

//         // Set source after player is ready
//         player.ready(() => {
//           player.src({
//             src: url,
//             type: getVideoType(url)
//           });
//         });

//         playerRef.current = player;
//       } catch (error) {
//         console.error('Error initializing video player:', error);
//       }
//     }, 0);

//     return () => {
//       clearTimeout(timer);
//       if (playerRef.current) {
//         playerRef.current.dispose();
//         playerRef.current = null;
//       }
//     };
//   }, [url]);

//   // Helper function to determine video type
//   const getVideoType = (url) => {
//     if (!url) return 'video/mp4';
    
//     const extension = url.split('.').pop()?.toLowerCase();
//     const typeMap = {
//       'mp4': 'video/mp4',
//       'webm': 'video/webm',
//       'ogg': 'video/ogg',
//       'mov': 'video/quicktime',
//       'avi': 'video/x-msvideo',
//       'm3u8': 'application/x-mpegURL'
//     };
    
//     return typeMap[extension] || 'video/mp4';
//   };

//   return (
//     <div className="azure-media-player-wrapper">
//       <video
//         ref={videoRef}
//         className="video-js vjs-default-skin vjs-azure-skin"
//         controls
//         preload="auto"
//         data-setup="{}"
//       />
//     </div>
//   );
// }


//import { useNavigate } from 'react-router-dom'; // If using React Router
// import videojs from 'video.js';
// import 'video.js/dist/video-js.css';





// import React, { useRef, useEffect, useState, useCallback } from 'react';
// import { useHistory, useLocation } from 'react-router-dom';

export function AzureMediaPlayer() {
  const videoRef = useRef(null);
  const history = useHistory();
  const location = useLocation();
  const url = location.state;

  // State for managing playback persistence and UI
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);
  const [volume, setVolume] = useState(1);
  const [lastWatched, setLastWatched] = useState(null);
  const [showControls, setShowControls] = useState(true);
  const [playbackRate, setPlaybackRate] = useState(1);
  const [isFullscreen, setIsFullscreen] = useState(false);
  // NEW STATE FOR SUBTITLES
  const [subtitles, setSubtitles] = useState([]); // Array of { src, srclang, label, default }

  // Generate unique key for this video
  const videoKey = useCallback(() => {
    if (!url) return null;
    return `video_${btoa(url).replace(/[^a-zA-Z0-9]/g, '').substring(0, 20)}`;
  }, [url]);

  // Save playback state to memory
  const savePlaybackState = useCallback((time, vol, isPlayingState) => {
    if (!videoKey()) return;

    const state = {
      currentTime: time,
      volume: vol,
      isPlaying: isPlayingState,
      lastWatched: new Date().toISOString(),
      url: url,
      playbackRate: playbackRate
    };

    // Using in-memory storage for Claude.ai compatibility
    window.videoPlaybackState = window.videoPlaybackState || {};
    window.videoPlaybackState[videoKey()] = state;

    setLastWatched(state.lastWatched);
  }, [videoKey, url, playbackRate]);

  // Load playback state from memory
  const loadPlaybackState = useCallback(() => {
    if (!videoKey()) return null;
    const savedState = window.videoPlaybackState?.[videoKey()];
    return savedState || null;
  }, [videoKey]);

  // Format time for display
  const formatTime = (seconds) => {
    if (!seconds || isNaN(seconds)) return '0:00';
    const hrs = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    const secs = Math.floor(seconds % 60);

    if (hrs > 0) {
      return `${hrs}:${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
    }
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  const handleGoBack = () => {
    // Save current state before leaving
    if (videoRef.current) {
      savePlaybackState(videoRef.current.currentTime, videoRef.current.volume, !videoRef.current.paused);
    }
    window.history.back();
  };

  // Toggle play/pause
  const togglePlayPause = () => {
    if (videoRef.current) {
      if (videoRef.current.paused) {
        videoRef.current.play();
      } else {
        videoRef.current.pause();
      }
    }
  };

  // Seek video
  const seekVideo = (seconds) => {
    if (videoRef.current) {
      videoRef.current.currentTime = Math.max(0, Math.min(videoRef.current.duration, videoRef.current.currentTime + seconds));
    }
  };

  // Change volume
  const changeVolume = (delta) => {
    if (videoRef.current) {
      const newVolume = Math.max(0, Math.min(1, videoRef.current.volume + delta));
      videoRef.current.volume = newVolume;
      setVolume(newVolume);
    }
  };

  // Change playback rate
  const changePlaybackRate = (rate) => {
    if (videoRef.current) {
      videoRef.current.playbackRate = rate;
      setPlaybackRate(rate);
    }
  };

  // Toggle fullscreen
  const toggleFullscreen = () => {
    if (videoRef.current) {
      if (!document.fullscreenElement) {
        videoRef.current.requestFullscreen().catch(err => {
          console.log('Error attempting to enable fullscreen:', err);
        });
      } else {
        document.exitFullscreen();
      }
    }
  };

  // Resume from last position
  const resumeFromLastPosition = () => {
    if (videoRef.current && currentTime > 0) {
      videoRef.current.currentTime = currentTime;
      videoRef.current.play();
    }
  };

  // Keyboard shortcuts
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA') return;

      switch (e.key) {
        case ' ':
          e.preventDefault();
          togglePlayPause();
          break;
        case 'ArrowLeft':
          e.preventDefault();
          seekVideo(-10);
          break;
        case 'ArrowRight':
          e.preventDefault();
          seekVideo(10);
          break;
        case 'ArrowUp':
          e.preventDefault();
          changeVolume(0.1);
          break;
        case 'ArrowDown':
          e.preventDefault();
          changeVolume(-0.1);
          break;
        case 'f':
        case 'F':
          e.preventDefault();
          toggleFullscreen();
          break;
        case 'm':
        case 'M':
          e.preventDefault();
          if (videoRef.current) {
            videoRef.current.muted = !videoRef.current.muted;
          }
          break;
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, []);

  // Auto-save progress periodically
  useEffect(() => {
    const interval = setInterval(() => {
      if (videoRef.current && !videoRef.current.paused) {
        savePlaybackState(videoRef.current.currentTime, videoRef.current.volume, true);
      }
    }, 5000); // Save every 5 seconds

    return () => clearInterval(interval);
  }, [savePlaybackState]);

  // Fullscreen change listener
  useEffect(() => {
    const handleFullscreenChange = () => {
      setIsFullscreen(!!document.fullscreenElement);
    };

    document.addEventListener('fullscreenchange', handleFullscreenChange);
    return () => document.removeEventListener('fullscreenchange', handleFullscreenChange);
  }, []);

  // Initialize video
  useEffect(() => {
    const videoElement = videoRef.current;
    if (!videoElement || !url) {
      setError('No video URL provided');
      setIsLoading(false);
      return;
    }

    setIsLoading(true);
    setError(null);

    // Load saved state
    const savedState = loadPlaybackState();
    if (savedState) {
      setCurrentTime(savedState.currentTime || 0);
      setVolume(savedState.volume || 1);
      setLastWatched(savedState.lastWatched);
      setPlaybackRate(savedState.playbackRate || 1);
    }

    // Set video source
    videoElement.src = url;
    videoElement.volume = savedState?.volume || 1;
    videoElement.playbackRate = savedState?.playbackRate || 1;

    // --- NEW: Load subtitles ---
    // This is a placeholder. In a real application, you would fetch this data
    // from an API or based on the video URL.
    const fetchedSubtitles = [
      { src: '/path/to/subtitles_en.vtt', srclang: 'en', label: 'English', default: true },
      { src: '/path/to/subtitles_es.vtt', srclang: 'es', label: 'Spanish' },
      { src: '/path/to/captions_fr.vtt', srclang: 'fr', label: 'French (Captions)', kind: 'captions' },
    ];
    setSubtitles(fetchedSubtitles);
    // --- END NEW ---

    // Event listeners
    const handleLoadedMetadata = () => {
      setDuration(videoElement.duration);
      setIsLoading(false);

      // Apply saved current time after metadata loads
      if (savedState?.currentTime > 0) {
        videoElement.currentTime = savedState.currentTime;
      }
    };

    const handleTimeUpdate = () => {
      setCurrentTime(videoElement.currentTime);
    };

    const handlePlay = () => {
      setIsPlaying(true);
    };

    const handlePause = () => {
      setIsPlaying(false);
      savePlaybackState(videoElement.currentTime, videoElement.volume, false);
    };

    const handleVolumeChange = () => {
      setVolume(videoElement.volume);
    };

    const handleEnded = () => {
      setIsPlaying(false);
      savePlaybackState(0, videoElement.volume, false);
    };

    const handleError = (e) => {
      console.error('Video error:', e);
      setError('Error loading video. Please check the URL and try again.');
      setIsLoading(false);
    };

    const handleLoadStart = () => {
      setIsLoading(true);
    };

    const handleCanPlay = () => {
      setIsLoading(false);
    };

    // Add event listeners
    videoElement.addEventListener('loadedmetadata', handleLoadedMetadata);
    videoElement.addEventListener('timeupdate', handleTimeUpdate);
    videoElement.addEventListener('play', handlePlay);
    videoElement.addEventListener('pause', handlePause);
    videoElement.addEventListener('volumechange', handleVolumeChange);
    videoElement.addEventListener('ended', handleEnded);
    videoElement.addEventListener('error', handleError);
    videoElement.addEventListener('loadstart', handleLoadStart);
    videoElement.addEventListener('canplay', handleCanPlay);

    return () => {
      // Save final state before cleanup
      if (videoElement) {
        savePlaybackState(videoElement.currentTime, videoElement.volume, !videoElement.paused);
      }

      // Remove event listeners
      videoElement.removeEventListener('loadedmetadata', handleLoadedMetadata);
      videoElement.removeEventListener('timeupdate', handleTimeUpdate);
      videoElement.removeEventListener('play', handlePlay);
      videoElement.removeEventListener('pause', handlePause);
      videoElement.removeEventListener('volumechange', handleVolumeChange);
      videoElement.removeEventListener('ended', handleEnded);
      videoElement.removeEventListener('error', handleError);
      videoElement.removeEventListener('loadstart', handleLoadStart);
      videoElement.removeEventListener('canplay', handleCanPlay);
    };
  }, [url, loadPlaybackState, savePlaybackState]);

  // Function to toggle subtitle visibility and language
  const handleSubtitleChange = (event) => {
    if (!videoRef.current) return;
    const selectedTrackLabel = event.target.value;

    Array.from(videoRef.current.textTracks).forEach(track => {
      if (track.label === selectedTrackLabel) {
        track.mode = 'showing'; // Enable this track
      } else {
        track.mode = 'hidden'; // Disable other tracks
      }
    });

    // If "Off" is selected, hide all tracks
    if (selectedTrackLabel === 'off') {
      Array.from(videoRef.current.textTracks).forEach(track => {
        track.mode = 'hidden';
      });
    }
  };


  if (error) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        backgroundColor: '#000',
        color: '#fff',
        flexDirection: 'column'
      }}>
        <button onClick={handleGoBack} style={{
          position: 'absolute',
          top: '20px',
          left: '20px',
          background: 'rgba(255, 255, 255, 0.9)',
          color: '#333',
          border: 'none',
          borderRadius: '50%',
          width: '50px',
          height: '50px',
          cursor: 'pointer',
          fontSize: '18px'
        }}>
          ←
        </button>
        <div style={{ textAlign: 'center' }}>
          <h2>⚠️ Error</h2>
          <p>{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div
      className="azure-media-player-wrapper"
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        width: '100%',
        backgroundColor: '#000',
        position: 'relative'
      }}
      onMouseMove={() => setShowControls(true)}
      onMouseLeave={() => setShowControls(false)}
    >
      {/* Go Back Button */}
      <button
        onClick={handleGoBack}
        style={{
          position: 'absolute',
          top: '20px',
          left: '20px',
          background: 'rgba(255, 255, 255, 0.9)',
          color: '#333',
          border: '2px solid rgba(0, 120, 215, 0.8)',
          borderRadius: '50%',
          width: '50px',
          height: '50px',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '18px',
          fontWeight: 'bold',
          transition: 'all 0.3s ease',
          zIndex: 1000,
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
          opacity: showControls ? 1 : 0.3
        }}
        onMouseEnter={(e) => {
          e.target.style.background = 'rgba(0, 120, 215, 0.9)';
          e.target.style.color = 'white';
          e.target.style.borderColor = 'rgba(0, 120, 215, 1)';
          e.target.style.transform = 'scale(1.1)';
          e.target.style.boxShadow = '0 6px 16px rgba(0, 120, 215, 0.4)';
        }}
        onMouseLeave={(e) => {
          e.target.style.background = 'rgba(255, 255, 255, 0.9)';
          e.target.style.color = '#333';
          e.target.style.borderColor = 'rgba(0, 120, 215, 0.8)';
          e.target.style.transform = 'scale(1)';
          e.target.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.3)';
        }}
        title="Go Back"
      >
        ←
      </button>

      {/* Video Info Panel */}
      {(lastWatched || currentTime > 0) && (
        <div style={{
          position: 'absolute',
          top: '20px',
          right: '20px',
          background: 'rgba(0, 0, 0, 0.8)',
          color: '#fff',
          padding: '10px 15px',
          borderRadius: '8px',
          fontSize: '12px',
          zIndex: 1000,
          maxWidth: '200px',
          opacity: showControls ? 1 : 0.3,
          transition: 'opacity 0.3s ease'
        }}>
          {lastWatched && (
            <div>Last watched: {new Date(lastWatched).toLocaleString()}</div>
          )}
          {currentTime > 0 && duration > 0 && (
            <div>
              Progress: {formatTime(currentTime)} / {formatTime(duration)}
              <div style={{
                width: '100%',
                height: '3px',
                background: 'rgba(255, 255, 255, 0.3)',
                borderRadius: '2px',
                marginTop: '5px'
              }}>
                <div style={{
                  width: `${(currentTime / duration) * 100}%`,
                  height: '100%',
                  background: 'rgba(0, 120, 215, 0.9)',
                  borderRadius: '2px'
                }} />
              </div>
            </div>
          )}
          <div>Speed: {playbackRate}x</div>
        </div>
      )}

      {/* Resume Button */}
      {currentTime > 30 && !isPlaying && (
        <button
          onClick={resumeFromLastPosition}
          style={{
            position: 'absolute',
            bottom: '120px',
            left: '50%',
            transform: 'translateX(-50%)',
            background: 'rgba(0, 120, 215, 0.9)',
            color: 'white',
            border: 'none',
            borderRadius: '25px',
            padding: '12px 24px',
            cursor: 'pointer',
            fontSize: '14px',
            fontWeight: 'bold',
            zIndex: 1000,
            boxShadow: '0 4px 12px rgba(0, 120, 215, 0.4)',
            transition: 'all 0.3s ease'
          }}
          onMouseEnter={(e) => {
            e.target.style.transform = 'translateX(-50%) scale(1.05)';
            e.target.style.boxShadow = '0 6px 16px rgba(0, 120, 215, 0.6)';
          }}
          onMouseLeave={(e) => {
            e.target.style.transform = 'translateX(-50%) scale(1)';
            e.target.style.boxShadow = '0 4px 12px rgba(0, 120, 215, 0.4)';
          }}
        >
          Resume from {formatTime(currentTime)}
        </button>
      )}

      {/* Loading Indicator */}
      {isLoading && (
        <div style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          color: '#fff',
          fontSize: '18px',
          zIndex: 1000,
          display: 'flex',
          alignItems: 'center',
          gap: '10px'
        }}>
          <div style={{
            width: '20px',
            height: '20px',
            border: '2px solid rgba(255, 255, 255, 0.3)',
            borderTop: '2px solid #fff',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite'
          }} />
          Loading video...
        </div>
      )}

      {/* Video Container */}
      <div style={{
        width: '90%',
        maxWidth: '1200px',
        position: 'relative'
      }}>
        <video
          ref={videoRef}
          style={{
            width: '100%',
            height: 'auto',
            minHeight: '400px',
            backgroundColor: '#000'
          }}
          controls={false}
          preload="metadata"
          onClick={togglePlayPause}
        >
          {/* NEW: Render track elements dynamically */}
          {subtitles.map((sub, index) => (
            <track
              key={index}
              kind={sub.kind || "subtitles"} // Default to "subtitles"
              src={sub.src}
              srcLang={sub.srclang}
              label={sub.label}
              default={sub.default || false} // Set one as default if needed
            />
          ))}
        </video>

        {/* Custom Control Bar */}
        <div style={{
          position: 'absolute',
          bottom: '0',
          left: '0',
          right: '0',
          background: 'linear-gradient(transparent, rgba(0, 0, 0, 0.8))',
          padding: '20px',
          opacity: showControls ? 1 : 0,
          transition: 'opacity 0.3s ease'
        }}>
          {/* Progress Bar */}
          <div style={{
            width: '100%',
            height: '4px',
            background: 'rgba(255, 255, 255, 0.3)',
            borderRadius: '2px',
            marginBottom: '10px',
            cursor: 'pointer'
          }}
            onClick={(e) => {
              const rect = e.currentTarget.getBoundingClientRect();
              const percent = (e.clientX - rect.left) / rect.width;
              if (videoRef.current) {
                videoRef.current.currentTime = percent * videoRef.current.duration;
              }
            }}>
            <div style={{
              width: `${duration > 0 ? (currentTime / duration) * 100 : 0}%`,
              height: '100%',
              background: 'rgba(0, 120, 215, 0.9)',
              borderRadius: '2px'
            }} />
          </div>

          {/* Control Buttons */}
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            color: '#fff'
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
              <button
                onClick={togglePlayPause}
                style={{
                  background: 'none',
                  border: 'none',
                  color: '#fff',
                  fontSize: '24px',
                  cursor: 'pointer'
                }}
              >
                {isPlaying ? '⏸️' : '▶️'}
              </button>

              <button
                onClick={() => seekVideo(-10)}
                style={{
                  background: 'none',
                  border: 'none',
                  color: '#fff',
                  fontSize: '18px',
                  cursor: 'pointer'
                }}
              >
                ⏪
              </button>

              <button
                onClick={() => seekVideo(10)}
                style={{
                  background: 'none',
                  border: 'none',
                  color: '#fff',
                  fontSize: '18px',
                  cursor: 'pointer'
                }}
              >
                ⏩
              </button>

              <span style={{ fontSize: '14px' }}>
                {formatTime(currentTime)} / {formatTime(duration)}
              </span>
            </div>

            <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
              {/* NEW: Subtitle/Caption Language Selector */}
              {subtitles.length > 0 && (
                <select
                  onChange={handleSubtitleChange}
                  style={{
                    background: 'rgba(255, 255, 255, 0.1)',
                    border: '1px solid rgba(255, 255, 255, 0.3)',
                    color: '#fff',
                    padding: '2px 5px',
                    borderRadius: '3px',
                    fontSize: '12px'
                  }}
                >
                  <option value="off">Subtitles Off</option>
                  {subtitles.map((sub, index) => (
                    <option key={index} value={sub.label}>
                      {sub.label}
                    </option>
                  ))}
                </select>
              )}

              <select
                value={playbackRate}
                onChange={(e) => changePlaybackRate(Number(e.target.value))}
                style={{
                  background: 'rgba(255, 255, 255, 0.1)',
                  border: '1px solid rgba(255, 255, 255, 0.3)',
                  color: '#fff',
                  padding: '2px 5px',
                  borderRadius: '3px',
                  fontSize: '12px'
                }}
              >
                <option value={0.25}>0.25x</option>
                <option value={0.5}>0.5x</option>
                <option value={0.75}>0.75x</option>
                <option value={1}>1x</option>
                <option value={1.25}>1.25x</option>
                <option value={1.5}>1.5x</option>
                <option value={1.75}>1.75x</option>
                <option value={2}>2x</option>
              </select>

              <button
                onClick={toggleFullscreen}
                style={{
                  background: 'none',
                  border: 'none',
                  color: '#fff',
                  fontSize: '18px',
                  cursor: 'pointer'
                }}
              >
                {isFullscreen ? '🔲' : '⛶'}
              </button>
            </div>
          </div>
        </div>

        {/* Keyboard Shortcuts Help */}
        <div style={{
          position: 'absolute',
          bottom: '-40px',
          left: '0',
          right: '0',
          color: 'rgba(255, 255, 255, 0.7)',
          fontSize: '12px',
          textAlign: 'center'
        }}>
          Space: Play/Pause | ←/→: Seek ±10s | ↑/↓: Volume | F: Fullscreen | M: Mute
        </div>
      </div>

      {/* CSS Animation for loading spinner */}
      <style jsx>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
}

//export default AzureMediaPlayer;